import { Component, computed, inject, input, output, signal } from '@angular/core';
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { HeaderSearchResult, SvgIconsComponent } from '@zayan-erp/shared';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { of } from 'rxjs';
import { ProductAttribute } from '../../models/product.model';
import { HeaderService } from '@zayan-erp/shared';

@Component({
  selector: 'lib-product-attribute-form',
  imports: [ToggleSwitchModule, SvgIconsComponent, FormsModule],
  templateUrl: './product-attribute-form.component.html',
  styleUrl: './product-attribute-form.component.scss'
})
export class ProductAttributeFormComponent {
  attribute = input<ProductAttribute>();
  assignValues = output<any[]>();

  #activatedRoute = inject(ActivatedRoute);
  #headerSearchService = inject(HeaderService);

  productId = signal<string | null>(this.#activatedRoute.snapshot.paramMap.get('id'));
  search = signal<string>('');
  isShowSelected = signal<boolean>(false);
  toggleAttributeValues = signal<number>(10);

  ngOnInit(): void {
    this.#headerSearchService.setSearchConfig({
      showSearch: true,
      showIcon: false,
      placeholder: 'Search in attributes',
      showSearchResults: false,

      search: (query: string) => {
        this.search.set(query);
        return of([]);
      },
      handleResult: (result: HeaderSearchResult) => {
        // Empty handler since you only want to set the local signal
      }
    });
  }

  isAllValuesSelected = computed(() => {
    const attributeValues = this.attributeValuesDisplay();
    return attributeValues && attributeValues.length > 0 && attributeValues.every((p: any) => p.isSelected);
  });

  attributeValuesDisplay = computed(() => {
    return this.attribute()
      ?.values.filter((value: any) => !this.isShowSelected() || value.isSelected)
      .filter((value: any) => value.value.toLowerCase().includes(this.search().toLowerCase()));
  });

  toggleSelectionAll() {
    if (!this.isAllValuesSelected()) {
      this.assignValues.emit(this.attributeValuesDisplay()?.filter((value: any) => !value.isSelected) ?? []);
    } else {
      this.assignValues.emit(this.attributeValuesDisplay()?.filter((value: any) => value.isSelected) ?? []);
    }
  }
}
